import { Headline, BrownRectangle, Container } from "./styles";

interface TopicProps {
    title: string;
}

const Topic: React.FC<TopicProps> = ({ title }) => {
    return (
        <Container>
            <Headline>{title}</Headline>
            <BrownRectangle/>
        </Container>
    );
}

export default Topic;
